import * as THREE from "three";

interface Props {
    color: string
    bgColor: string
}
const Bases = (props:Props) => {
    const cornerBase = new THREE.Shape()
        .moveTo(0, 0)
        .lineTo(0, 18/12)
        .lineTo(18/12, 18/12)
        .lineTo(18/12, 0)
        .lineTo(0, 0)
    const centerBase = new THREE.Shape()
        .moveTo(-9/12, -9/12)
        .lineTo(-9/12, 9/12)
        .lineTo(9/12, 9/12)
        .lineTo(9/12, -9/12)
        .lineTo(-9/12, -9/12)

  return (
    <>
    <mesh position={[754/12,754/12,0]} rotation={[0,0,Math.PI/4]}>
        <shapeGeometry args={[cornerBase]} />
        <meshBasicMaterial color={props.color} />
    </mesh>
    <mesh position={[-754/12,754/12,0]} rotation={[0,0,Math.PI/4]}>
        <shapeGeometry args={[cornerBase]} />
        <meshBasicMaterial color={props.color} />
    </mesh>
    <mesh position={[0,127.28,0]} rotation={[0,0,Math.PI/4]}>
        <shapeGeometry args={[centerBase]} />
        <meshBasicMaterial color={props.color} />
    </mesh>
    
    </>
  )
}

export default Bases